import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MovementsMobileComponent } from './mobile/movements/movements.component';
import { MovementMobileComponent } from './mobile/movements/movement.component';
import { MovementsComponent } from './backoffice/movements/movements.component';
import { MovementComponent } from './backoffice/movements/movement.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MapaComponent } from './mapas/mapa.component';
import { AnnouncementsComponent } from './backoffice/announcements/announcements.component';
import { AnnouncementComponent } from './backoffice/announcements/announcement.component';
import { AnnouncementItemsComponent } from './backoffice/announcementItems/announcementItems.component';
import { CustomerComponent } from './backoffice/customers/customer.component';
import { CustomerReportsComponent } from './customerReports/customer-reports.component';
import { CustomerReportsDetailComponent } from './customerReports/customer-reports-detail.component';
import { CustomerReportsLoadTruckComponent } from './customerReports/customer-reports-loadtruck.component';


import { TemplateComponent } from './config/templates/template.component';
import { UsersComponent } from './config/users/users.component';
import { UserComponent } from './config/users/user.component';
import { ProfileComponent } from '../auth/profile.component';

import { DynamicFormModule } from '../dynamic-form/dynamic-form.module';
import {
    DynamicEntityModule, DynamicDetailComponent,
    DynamicGridComponent, DynamicListDetailComponent
} from '../dynamic-entity/dynamic-entity.module';

import { AuthGuard } from '../ubi-core/auth-guard.service';

const moduleRoutes: Routes = [
    {
        path: 'config/producttypes', component: DynamicListDetailComponent, canActivate: [AuthGuard],
        data: { entity: 'producttypes', roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE'] }
    },
    {
        path: 'config/customertypes', component: DynamicListDetailComponent, canActivate: [AuthGuard],
        data: { entity: 'customertypes', roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE'] }
    },
    {
        path: 'config/damages', component: DynamicGridComponent, canActivate: [AuthGuard],
        data: { entity: 'damages', navigateUrl: 'config/damage', roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE'] }
    },
    {
        path: 'config/damage', component: DynamicDetailComponent, canActivate: [AuthGuard],
        data: { entity: 'damages', roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE'] }
    },
    {
        path: 'config/damage/:id', component: DynamicDetailComponent, canActivate: [AuthGuard],
        data: { entity: 'damages', roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE'] }
    },
    {
        path: 'config/customers', component: DynamicGridComponent, canActivate: [AuthGuard],
        data: { entity: 'customers', navigateUrl: 'config/customer', roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE'] }
    },
    {
        path: 'config/customer', component: CustomerComponent, canActivate: [AuthGuard],
        data: { entity: 'customers', roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE'] }
    },
    {
        path: 'config/customer/:id', component: CustomerComponent, canActivate: [AuthGuard],
        data: { entity: 'customers', roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE'] }
    },

    {
        path: 'config/templates', component: DynamicGridComponent, canActivate: [AuthGuard],
        data: { entity: 'templates', navigateUrl: 'config/template', roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE'] }
    },
    {
        path: 'config/template', component: TemplateComponent, canActivate: [AuthGuard],
        data: { entity: 'templates', roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE'] }
    },
    {
        path: 'config/template/:id', component: TemplateComponent, canActivate: [AuthGuard],
        data: { entity: 'templates', roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE'] }
    },
    {
        path: 'config/vesselandprocesses', component: DynamicGridComponent, canActivate: [AuthGuard],
        data: {
            entity: 'vesselandprocesses', navigateUrl: 'config/vesselandprocess',
            roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE']
        }
    },
    {
        path: 'config/vesselandprocess', component: DynamicDetailComponent, canActivate: [AuthGuard],
        data: {
            entity: 'vesselandprocesses',
            roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE']
        }
    },
    {
        path: 'config/vesselandprocess/:id', component: DynamicDetailComponent, canActivate: [AuthGuard],
        data: {
            entity: 'vesselandprocesses',
            roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE']
        }
    },
    {
        path: 'config/truckingcompanies', component: DynamicListDetailComponent, canActivate: [AuthGuard],
        data: {
            entity: 'truckingcompanies', navigateUrl: 'config/truckingcompany',
            roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE']
        }
    },
    {
        path: 'config/zones', component: DynamicListDetailComponent, canActivate: [AuthGuard],
        data: {
            entity: 'zones', navigateUrl: 'config/zone',
            roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE']
        }
    },
    {
        path: 'config/producttypeZoneDamages', component: DynamicGridComponent, canActivate: [AuthGuard],
        data: {
            entity: 'producttypeZoneDamages', navigateUrl: 'config/producttypeZoneDamage',
            roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE']
        }
    },
    {
        path: 'config/producttypeZoneDamage', component: DynamicDetailComponent, canActivate: [AuthGuard],
        data: {
            entity: 'producttypeZoneDamages',
            roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE']
        }
    },
    {
        path: 'config/producttypeZoneDamage/:id', component: DynamicDetailComponent, canActivate: [AuthGuard],
        data: {
            entity: 'producttypeZoneDamages',
            roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE']
        }
    },
    {
        path: 'config/qrcodesrules', component: DynamicGridComponent, canActivate: [AuthGuard],
        data: { entity: 'qrcodesrules', navigateUrl: 'config/qrcodesrule', roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE'] }
    },
    {
        path: 'config/qrcodesrule', component: DynamicDetailComponent, canActivate: [AuthGuard],
        data: { entity: 'qrcodesrules', roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE'] }
    },
    {
        path: 'config/qrcodesrule/:id', component: DynamicDetailComponent, canActivate: [AuthGuard],
        data: { entity: 'qrcodesrules', roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE'] }
    },
    {
        path: 'config/configurations', component: DynamicGridComponent, canActivate: [AuthGuard],
        data: { entity: 'configurations', navigateUrl: 'config/configuration', roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE'] }
    },
    {
        path: 'config/configuration', component: DynamicDetailComponent, canActivate: [AuthGuard],
        data: { entity: 'configurations', roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE'] }
    },
    {
        path: 'config/configuration/:id', component: DynamicDetailComponent, canActivate: [AuthGuard],
        data: { entity: 'configurations', roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE'] }
    },
    {
        path: 'backoffice/announcements', component: AnnouncementsComponent, canActivate: [AuthGuard],
        data: {
            entity: 'announcements', navigateUrl: 'backoffice/announcement',
            roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE', 'ANNOUNCEMENTS_ROLE', 'BACKOFFICE_ROLE']
        }
    },
    {
        path: 'backoffice/announcement', component: AnnouncementComponent, canActivate: [AuthGuard],
        data: { roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE', 'ANNOUNCEMENTS_ROLE', 'BACKOFFICE_ROLE'] }
    },
    {
        path: 'backoffice/announcement/:id', component: AnnouncementComponent, canActivate: [AuthGuard],
        data: { roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE', 'ANNOUNCEMENTS_ROLE', 'BACKOFFICE_ROLE'] }
    },

    {
        path: 'backoffice/announcementItems', component: AnnouncementItemsComponent, canActivate: [AuthGuard],
        data: {
            entity: 'announcementItems', navigateUrl: 'backoffice/announcement',
            roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE', 'ANNOUNCEMENTS_ROLE', 'BACKOFFICE_ROLE']
        }
    },
    {
        path: 'backoffice/movements', component: MovementsComponent, canActivate: [AuthGuard],
        data: {
            entity: 'movements', navigateUrl: 'backoffice/movement',
            roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE', 'MOVEMENTS_ROLE', 'BACKOFFICE_ROLE']
        }
    },
    {
        path: 'backoffice/movement', component: DynamicDetailComponent, canActivate: [AuthGuard],
        data: { entity: 'movements', roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE', 'MOVEMENTS_ROLE', 'BACKOFFICE_ROLE'] }
    },
    {
        path: 'backoffice/movement/:id', component: MovementComponent, canActivate: [AuthGuard],
        data: { entity: 'movements', roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE', 'MOVEMENTS_ROLE', 'BACKOFFICE_ROLE'] }
    },

    {
        path: 'customer/dayMovementsResume', component: CustomerReportsComponent, canActivate: [AuthGuard],
        data: { entity: 'customerreports', navigateUrl: 'customer/dayMovementsDetail', roles: ['CUSTOMER_ROLE'] }
    },
    {
        path: 'customer/dayMovementsDetail/:vesselAndProcessId/:timestamp/:soldToId/:shipToId',
        component: CustomerReportsDetailComponent, canActivate: [AuthGuard],
        data: { entity: 'customerreports', roles: ['CUSTOMER_ROLE'] }
    },
    {
        path: 'customer/dayMovementsDetail', component: CustomerReportsDetailComponent, canActivate: [AuthGuard],
        data: { entity: 'customerreports', roles: ['CUSTOMER_ROLE'] }
    },
    {
        path: 'customer/loadtruck', component: CustomerReportsLoadTruckComponent, canActivate: [AuthGuard],
        data: { entity: 'customerreports', roles: ['CUSTOMER_ROLE'] }
    },
    {
        path: 'backoffice/movement', component: DynamicDetailComponent, canActivate: [AuthGuard],
        data: { entity: 'movements', roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE', 'MOVEMENTS_ROLE', 'BACKOFFICE_ROLE'] }
    },

    {
        path: 'mobile/movements', component: MovementsMobileComponent, canActivate: [AuthGuard],
        data: { roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE', 'MOVEMENTS_ROLE', 'BACKOFFICE_ROLE', 'OPERATOR_ROLE'] }
    },
    {
        path: 'mobile/movement/:type', component: MovementMobileComponent, canActivate: [AuthGuard],
        data: { roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE', 'MOVEMENTS_ROLE', 'BACKOFFICE_ROLE', 'OPERATOR_ROLE'] }
    },
    {
        path: 'mobile/movement/:type/:id', component: MovementMobileComponent, canActivate: [AuthGuard],
        data: { roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE', 'MOVEMENTS_ROLE', 'BACKOFFICE_ROLE', 'OPERATOR_ROLE'] }
    },
    {
        path: 'maps/loadtruck', component: MapaComponent, canActivate: [AuthGuard],
        data: { entity: 'movements', roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE', 'BACKOFFICE_ROLE'] }
    },
    {
        path: 'maps/reports', component: MapaComponent, canActivate: [AuthGuard],
        data: { entity: 'movements', roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE', 'BACKOFFICE_ROLE'] }
    },
    {
        path: 'maps/dayMovementsResume', component: CustomerReportsComponent, canActivate: [AuthGuard],
        data: { entity: 'customerreports', navigateUrl: 'maps/dayMovementsDetail', 
                roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE', 'BACKOFFICE_ROLE'],
                hasCustomerFilter: true
             }
    },
    {
        path: 'maps/dayMovementsDetail/:customerId/:vesselAndProcessId/:timestamp/:soldToId/:shipToId',
        component: CustomerReportsDetailComponent, canActivate: [AuthGuard],
        data: { entity: 'customerreports', roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE', 'BACKOFFICE_ROLE'], hasCustomerFilter: true }
    },
    {
        path: 'maps/dayMovementsDetail', component: CustomerReportsDetailComponent, canActivate: [AuthGuard],
        data: { entity: 'customerreports', roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE', 'BACKOFFICE_ROLE'], hasCustomerFilter: true }
    },
    {
        path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard],
        data: { roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE', 'MOVEMENTS_ROLE', 'BACKOFFICE_ROLE', 'OPERATOR_ROLE', 'CUSTOMER_ROLE'] }
    },
    {
        path: 'config/users', component: UsersComponent, canActivate: [AuthGuard],
        data: {
            entity: 'auth', navigateUrl: 'config/user', roles: ['ADMIN_ROLE']
        }
    },
    {
        path: 'config/user', component: UserComponent, canActivate: [AuthGuard],
        data: { entity: 'auth', navigateUrl: 'config/users', roles: ['ADMIN_ROLE'] }
    },
    {
        path: 'config/user/:id', component: UserComponent, canActivate: [AuthGuard],
        data: { entity: 'auth', navigateUrl: 'config/users', roles: ['ADMIN_ROLE'] }
    },
    {
        path: 'profile', component: ProfileComponent, canActivate: [AuthGuard],
        data: { roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE', 'MOVEMENTS_ROLE', 'BACKOFFICE_ROLE', 'OPERATOR_ROLE', 'CUSTOMER_ROLE'] }
    },
    {
        path: '', component: DashboardComponent, canActivate: [AuthGuard],
        data: { roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE', 'MOVEMENTS_ROLE', 'BACKOFFICE_ROLE', 'OPERATOR_ROLE', 'CUSTOMER_ROLE'] }
    },
    {
        path: '**', component: DashboardComponent, canActivate: [AuthGuard],
        data: { roles: ['ADMIN_ROLE', 'ADVANCED_USER_ROLE', 'MOVEMENTS_ROLE', 'BACKOFFICE_ROLE', 'OPERATOR_ROLE', 'CUSTOMER_ROLE'] }
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(moduleRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class BaseRoutingModule {

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/base/base-routing.module.ts